import { useState } from "react";
import { Sparkles, ChevronDown, ChevronUp, RefreshCw } from "lucide-react";
import api from "../lib/api";

export const AIInsightBanner = ({ context, title = "Vexen AI insight" }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");

  const generate = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/ai/narrative", { context });
      setText(data.narrative);
      setOpen(true);
    } catch (e) {
      setText("Insight unavailable.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-amber-50/60 border border-amber-200/80 rounded-md" data-testid="ai-insight-banner">
      <button
        onClick={() => (text ? setOpen(!open) : generate())}
        className="w-full flex items-center gap-3 px-4 py-2.5 text-left"
        data-testid="ai-insight-toggle"
      >
        <div className="w-7 h-7 rounded-md bg-gold/15 flex items-center justify-center">
          <Sparkles size={14} className="text-amber-700" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.16em] text-amber-800 font-mono">
            Strategic Narrative
          </div>
          <div className="text-sm font-semibold text-slate-900 truncate">
            {text ? title : "Tap to generate executive narrative"}
          </div>
        </div>
        {loading ? (
          <RefreshCw size={14} className="animate-spin text-amber-700" />
        ) : (
          open ? <ChevronUp size={14} className="text-amber-700" /> : <ChevronDown size={14} className="text-amber-700" />
        )}
      </button>
      {open && text && (
        <div className="px-4 pb-4 text-sm leading-relaxed text-slate-700 whitespace-pre-line">
          {text}
          <button
            onClick={generate}
            className="block mt-3 text-xs text-amber-800 hover:text-amber-900 underline font-medium"
            data-testid="ai-insight-regenerate"
          >
            Regenerate
          </button>
        </div>
      )}
    </div>
  );
};
